import React from 'react';
import classnames from 'classnames/bind';

import styles from './profileImageStyles';

const cx = classnames.bind(styles);

export const IMAGE_SIZES = {
  TINY: 'tiny',
  SMALLER: 'smaller',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

const ProfileImage = ({
  className = '',
  source,
  shape = 'circle',
  size = 'medium',
  altText = '',
  style = '',
  noMargin = false,
  noBorder = false
}) => {
  style = style || className;
  return (
    <span className={cx(styles[`${size}`], 'wrap', { noMargin, noBorder })}>
      <img
        className={cx(styles[`image-${size}`], styles[shape], style)}
        src={source}
        alt={altText}
      />
    </span>
  );
};

export default ProfileImage;
